import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import {
  TopBar, Button, IconButton,
  Tooltip, TooltipTrigger, TooltipContent,
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@kuda/ui";
import { HouseIcon, CircleUserIcon, SunIcon, MoonIcon } from "@kuda/ui/icons";
import { useThemeContext } from '../theme/ThemeContext';
import argocdlIcon from "./images/ArgoCD.png";

const AppMenuBar = () => {
  const IsAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { mode, toggleTheme } = useThemeContext();

  const handleLogout = async () => {
    try {
      await instance.logout();
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      navigate("/");
    }
  };

  const handleUserInfo = () => {
    navigate("/user-info");
  };

  return (
    <TopBar
      left={
        <div className="flex items-center gap-3">
          <Link to="/" aria-label="Home">
            <IconButton fill="Transparent" icon={<HouseIcon className="size-5" />} />
          </Link>
          <span className="font-heading text-lg font-bold">Application Secrets</span>
        </div>
      }
      right={
        IsAuthenticated ? (
          <div className="flex items-center gap-3">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="outlined" asChild>
                  <a href="https://gitops.inkuda.com/applications">
                    <img src={argocdlIcon} alt="argocd" className="size-5" />
                    ArgoCD
                  </a>
                </Button>
              </TooltipTrigger>
              <TooltipContent>Return to Argocd UI</TooltipContent>
            </Tooltip>

            <IconButton
              fill="Transparent"
              onClick={toggleTheme}
              icon={mode === 'dark' ? <SunIcon className="size-5" /> : <MoonIcon className="size-5" />}
              aria-label="Toggle theme"
            />

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <IconButton fill="Transparent" icon={<CircleUserIcon className="size-5" />} aria-label="Account" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem onSelect={handleUserInfo}>User info</DropdownMenuItem>
                <DropdownMenuItem onSelect={handleLogout}>Logout</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        ) : null
      }
    />
  );
};

export default AppMenuBar;
